exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-top-enter-active[data-v-4c2a6062],.fade-top-leave-active[data-v-4c2a6062]{-webkit-transition:opacity .2s ease,-webkit-transform .2s ease;transition:opacity .2s ease,-webkit-transform .2s ease;transition:transform .2s ease,opacity .2s ease;transition:transform .2s ease,opacity .2s ease,-webkit-transform .2s ease}.fade-top-enter[data-v-4c2a6062],.fade-top-leave-to[data-v-4c2a6062]{-webkit-transform:translateY(-5px);transform:translateY(-5px);opacity:0}", ""]);

// exports
